import type { ObservationDeleteButtonWrapperProps } from "./observation-delete-button.type";

import { ObservationDeleteButton } from "./observation-delete-button.component";

export const ObservationDeleteButtonWrapper = ({
  observation,
  ...options
}: ObservationDeleteButtonWrapperProps) => {
  if (!observation) return null;

  return <ObservationDeleteButton observation={observation} {...options} />;
};
